// TODO: TESTS
import React, { useState, useCallback, useRef } from 'react';
import { AcademySearchProps } from '../../../types/components/academy/indexPage/AcademySearch';
import { SearchIcon } from '../../../modules/Icons';
import debounce from 'lodash.debounce';

const TEXT_SEARCH_DEBOUNCE_MS = 300;

const AcademySearch: React.FC<AcademySearchProps> = ({
  onSearch,
  defaultSearchTerm = '',
  placeholder = 'Search tutorials and resources',
  isLoading = false,
}) => {
  const [searchTerm, setSearchTerm] = useState(defaultSearchTerm);
  const inputRef = useRef<HTMLInputElement>(null);

  const debouncedSearch = useCallback(
    debounce((nextValue: string) => {
      onSearch(nextValue);
    }, TEXT_SEARCH_DEBOUNCE_MS),
    [onSearch]
  );

  const handleTextSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = e.target.value;
    setSearchTerm(nextValue);
    debouncedSearch(nextValue);
  };

  return (
    <div className="w-full mb-6">
      <div className="relative">
        <div className="rounded-[5px] flex items-center px-4 py-3 bg-a-dark-gray">
          <SearchIcon className="inline w-4 stroke-white" />
          <input
            ref={inputRef}
            className="w-full pl-2 text-sm bg-transparent outline-0"
            placeholder={placeholder}
            onChange={handleTextSearch}
            defaultValue={defaultSearchTerm}
          />
          {isLoading && (
            <div className="w-4 h-4 border-t-2 border-b-2 border-white rounded-full animate-spin"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AcademySearch;